'use client';
import Input from '@/components/Input';
import { IRepositoryBranch } from '@/lib/repositoryBranchesApi';
import * as Icon from '@/ui/Icon';
import { IRepository } from '@/types';

const BranchSelect: React.FC<{
  repository: IRepository;
  branches: IRepositoryBranch[];
  selectedBranch?: IRepositoryBranch;
  placeholder?: string;
  disabled?: boolean;
  onChange: (branch: IRepositoryBranch | undefined) => void;
}> = ({ repository, branches, selectedBranch, placeholder = 'Select..', disabled, onChange }) => {
  return (
    <Input.SelectControl
      name="repository-branch"
      wide
      options={branches.map((branch) => ({ value: branch.name, label: branch.name }))}
      selectedValue={selectedBranch?.name || repository.default_branch}
      onChange={(v) => onChange(branches.find((branch) => branch?.name === v))}
      isSearchable={false}
      prefixElement={<Icon.Branch className="prefix-icon" />}
      placeholder={placeholder}
      disabled={disabled}
      styles={{
        option: (styles, state) => ({
          ...styles,
          whiteSpace: 'nowrap',
        }),
      }}
    ></Input.SelectControl>
  );
};

export default BranchSelect;
